import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SubscribeForm from '@/components/feature/SubscribeForm';
import useSeo from '@/hooks/useSeo';
import { stats } from '@/mocks/posts';

const principles = [
  {
    icon: 'ri-shield-check-line',
    title: '先证据，后立场',
    text: '看到截图先问来源，看到爆料先查时间。我们不会因为一条内容"看起来很像真的"就直接发出，也不替读者预设立场。',
  },
  {
    icon: 'ri-git-commit-line',
    title: '时间线优先于结论',
    text: '事件还在发展中时，我们更愿意给一条清晰的时间线，而不是抢先给一个痛快但可能打脸的结论。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '隐私高于流量',
    text: '素人投稿会做脱敏处理，未经同意的个人信息不上墙。爆料的快感，不该建立在别人的麻烦之上。',
  },
  {
    icon: 'ri-refresh-line',
    title: '有反转就更新',
    text: '我们会在原文里追加更新说明，而不是删掉重发。读者看到的内容，始终是当前最完整的那一版。',
  },
];

const testimonials = [
  {
    name: '追更三年的老读者 · 阿哲',
    text: '以前刷热搜只能看到碎片，来这里能一次性看完前因后果。最舒服的是它不急着给结论，看完不会觉得自己被带节奏。',
  },
  {
    name: '常年潜水的水友 · 小南',
    text: '半夜刷到的瓜，第二天早上这里就已经整理好时间线了，速度真的快。深度追踪那几篇我反复看了两遍。',
  },
  {
    name: '一位匿名投稿人',
    text: '投稿之后编辑回复得很快，还主动帮我把里面的个人称呼处理掉了。这种被尊重的感觉挺难得的。',
  },
];

const ABOUT_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于 18爆料网',
    inLanguage: 'zh-CN',
    description: '18爆料网的品牌介绍、内容原则、用户口碑与联系方式。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '18爆料网',
    email: 'tips@18bolaodaily.example',
    description: '娱乐爆料资讯聚合站，每日更新明星八卦、网红翻车、素人投稿与深度追踪。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  },
];

export default function AboutPage() {
  useSeo({
    title: '关于我们 | 18爆料网品牌介绍与内容原则',
    description:
      '了解 18爆料网的品牌定位、发展理念与内容原则。我们把零散热搜整理成完整时间线，坚持先证据后立场，每日更新最新猛料与热门爆料。',
    keywords: '18爆料网,关于18爆料网,18爆料网内容原则,18爆料网投稿',
    path: '/about',
    jsonLd: ABOUT_JSONLD,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="w-full">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <header className="w-full px-4 pb-10 md:px-8">
          <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-information-line" aria-hidden="true"></i>
                关于 18爆料网
              </span>
              <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
                把瓜吃明白，是我们唯一想做的事
              </h1>
              <p className="mt-5 text-base leading-relaxed text-foreground-600">
                18爆料网是一个娱乐爆料资讯聚合站。我们不做情绪搬运，只把散落在各处的碎片整理成一条看得懂的线：
                谁在什么时候做了什么、各方怎么回应、后来又发生了什么。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/"
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  看今日爆料
                </Link>
                <a
                  href="#contact"
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className="ri-mail-line" aria-hidden="true"></i>
                  联系我们
                </a>
              </div>
            </div>
            <div className="h-[260px] w-full overflow-hidden rounded-lg md:h-[360px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20desk%20with%20stacked%20newspapers%2C%20vintage%20camera%2C%20coffee%20cup%20and%20notebook%20on%20wooden%20table%2C%20no%20people%2C%20soft%20morning%20light%2C%20cinematic%20photography%20high%20detail%2C%20consistent%20warm%20textured%20background&width=1280&height=900&seq=bla-about-hero&orientation=landscape"
                alt="摆满报纸、相机与笔记本的编辑工作台"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </header>

        <section className="w-full px-4 py-8 md:px-8" aria-label="网站数据">
          <div className="grid grid-cols-2 gap-4 rounded-lg border border-background-200 bg-background-100 px-6 py-8 lg:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label} className="text-center">
                <p className="font-heading text-3xl font-bold text-primary-600 md:text-4xl">
                  {item.value}
                  <span className="ml-1 text-base font-medium text-foreground-500">{item.unit}</span>
                </p>
                <p className="mt-2 text-xs text-foreground-600 md:text-sm">{item.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="w-full px-4 py-10 md:px-8" aria-labelledby="position-heading">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div>
              <h2 id="position-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                网站定位
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                我们服务于一群"想把事情看全"的读者。对他们来说，一条热搜只是入口，真正有价值的是后面还没被讲完的部分。
                所以 18爆料网 的存在，是为了填补热搜和长文之间的那段空白。
              </p>
              <ul className="mt-5 space-y-3 text-sm text-foreground-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                  面向喜欢追热点、也想看完整逻辑的读者
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                  内容以短平快的每日更新为主，深度追踪为辅
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                  所有栏目均可长期追更，不怕错过后续
                </li>
              </ul>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <h2 className="font-heading text-xl font-bold text-foreground-950">发展理念</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                娱乐内容不等于粗制滥造。我们相信，哪怕是最"轻"的瓜，也值得被认真整理：来源写清楚、时间对得上、有反转就更新。
                当读者愿意花两分钟看完一篇，而不是划走三十条标题，这件事才算做对了。
              </p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                我们也在持续打磨投稿机制，希望每一个愿意说点什么的人，都能被认真对待。
              </p>
            </div>
          </div>
        </section>

        <section id="principles" className="w-full scroll-mt-20 bg-foreground-950 px-4 py-12 md:px-8" aria-labelledby="principles-heading">
          <h2 id="principles-heading" className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            内容原则 · 四条底线
          </h2>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-background-300">
            这些原则不是口号，而是每一篇稿件发出去之前都会被检查一遍的清单。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-800 bg-background-900 p-5">
                <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-background-50">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-300">{item.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="w-full px-4 py-12 md:px-8" aria-labelledby="voice-heading">
          <h2 id="voice-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            读者怎么说
          </h2>
          <p className="mt-3 text-sm text-foreground-600">来自长期追更读者与投稿人的真实留言。</p>
          <div className="mt-7 grid grid-cols-1 gap-5 lg:grid-cols-3">
            {testimonials.map((item) => (
              <blockquote
                key={item.name}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
              >
                <i className="ri-double-quotes-l mb-3 text-2xl text-accent-500" aria-hidden="true"></i>
                <p className="flex-1 text-sm leading-loose text-foreground-700">{item.text}</p>
                <footer className="mt-4 border-t border-background-200 pt-3 text-xs font-medium text-foreground-500">
                  {item.name}
                </footer>
              </blockquote>
            ))}
          </div>
        </section>

        <section id="contact" className="w-full scroll-mt-20 px-4 py-12 md:px-8" aria-labelledby="contact-heading">
          <div className="grid grid-cols-1 gap-8 rounded-lg bg-background-100 p-6 lg:grid-cols-[1fr_1.3fr] md:p-10">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                联系方式
              </span>
              <h2 id="contact-heading" className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                有料要爆，或想聊聊合作
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                投稿、纠错、侵权处理、内容合作，都可以通过下面任一方式找到我们。涉及个人权益的请求，我们会优先处理。
              </p>
              <ul className="mt-6 space-y-4 text-sm">
                <li className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-mail-line" aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">投稿与线索</span>
                    <span className="font-medium text-foreground-900">tips@18bolaodaily.example</span>
                  </span>
                </li>
                <li className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className="ri-copyright-line" aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">侵权与权益</span>
                    <span className="font-medium text-foreground-900">rights@18bolaodaily.example</span>
                  </span>
                </li>
                <li className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className="ri-time-line" aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">回复时效</span>
                    <span className="font-medium text-foreground-900">工作日 1 个工作日内</span>
                  </span>
                </li>
              </ul>
            </div>
            <SubscribeForm />
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}